<template>
  <div class="w3-container w3-row w3-center w3-dark-grey w3-padding-64">
    <!-- <div class="w3-quarter"> -->
    <div class="w3-quarter">
      <span class="w3-xxlarge">10+</span>
      <br><span>{{ $t('stats.partners') }}</span>
    </div>
    <div class="w3-quarter">
      <span class="w3-xxlarge">14+</span>
      <br><span>{{ $t('stats.projects') }}</span>
    </div>
    <!-- <div class="w3-quarter">
      <span class="w3-xxlarge">89+</span>
      <br><span>{{ $t('stats.clients') }}</span>
    </div> -->
    <div class="w3-quarter">
      <span class="w3-xxlarge">90+</span>
      <br><span>{{ $t('stats.meetings') }}</span>
    </div>
    <div class="w3-quarter">
      <span class="w3-xxlarge">1+</span>
      <br><span>{{ $t('stats.planets') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatsSection'
}
</script>